import { useTranslation, Trans } from "react-i18next";

import Fade from "react-reveal/Fade";

import main from "../../img/Home/main.png";
import alm from "../../img/Products/main.png";
import ab from "../../img/Home/ab.png";

import abm from '../../img/Home/cristalmob.png'
import almm from '../../img/Home/wavemob.png'

import Button from "../Button";

function Main() {
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden">
      <img src={alm} alt="alm decoration" className="absolute z-50 right-0 bottom-0"/>
      <img
        src={main}
        alt="main background"
        className="h-[900px] md:h-[700px] w-full object-cover"
      />
      <img
        src={ab}
        alt="ab decoration"
        className="absolute top-0 right-0 h-full z-20 hidden md:block"
      />
      <img
        src={almm}
        alt="ab decoration"
        className="absolute bottom-0 right-0 w-full z-20 md:hidden block"
      />
      
      <div className="absolute flex flex-col md:flex-row justify-between z-50 top-0 left-1/2 -translate-x-1/2 w-full max-w-[1220px] px-5">
        <div className="relative">
            <Fade left><p className="max-w-[692px] mt-[40px] md:mt-[100px] poppins text-[36px] xl:text-[72px] spanmain font-[500] text-[#061A77] leading-[1.2]"><Trans>{t('products.1')}</Trans></p></Fade>
            <Fade left delay={200}><p className="poppins font-[275] leading-[1.2] text-[24px] xl:text-[48px] text-[#061A77]">{t('products.2')}</p></Fade>
            <Fade left delay={400}><p className="mt-[20px] max-w-[517px] inter text-[14px] text-[#000000B2]">{t('products.3')}</p></Fade>
            <Fade left delay={600}><div className="mt-[100px]"><Button/></div></Fade>
        </div>
      </div>
    </div>
  );
}

export default Main;
